import './Dialog-dce13989.css';

var classes = {"Overlay":"prc-DialogV1-Overlay-MGryS","CloseIcon":"prc-DialogV1-CloseIcon-7vlJU","Dialog":"prc-DialogV1-Dialog-jJXoP","Header":"prc-DialogV1-Header-RrOAq","HeaderChild":"prc-DialogV1-HeaderChild-plRx5"};

export { classes as default };
